import { AutocompleteInput } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Landmark } from "lucide-react";
import { Edit, ReferenceInput, SimpleForm, TextInput } from "../common";

export const DepartmentEdit = () => (
  <Edit title="Edit Department" actions={false}>
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <Landmark className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Edit Department Details</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput source="name" label="Department Name" />
            <TextInput source="code" label="Department Code" />
            <ReferenceInput source="head_employee_id" reference="employees">
              <AutocompleteInput label="Department Head" optionText="name" />
            </ReferenceInput>
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Edit>
);
